<!--
    ~ VNCmail : A whole new experience in enterprise email communication.
    ~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
    ~
    ~ This program is free software: you can redistribute it and/or modify
    ~ it under the terms of the GNU Affero General Public License as published by
    ~ the Free Software Foundation, version 3 of the License.
    ~
    ~ This program is distributed in the hope that it will be useful,
    ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
    ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
    ~ GNU Affero General Public License for more details.
    ~
    ~ You should have received a copy of the GNU Affero General Public License
    ~ along with this program. Look for COPYING file in the top folder.
    ~ If not, see http://www.gnu.org/licenses/.
    -->
    <div class="file-preview-dialog-main">
      <div class="header-item">
        <div class="back_button">
            <mat-icon (click)="close()" id="hidePreviewMobile">arrow_back</mat-icon>
        </div>
        <div class="lbl">
            <span *ngIf="!!attachment && !!attachment.filename"> {{ attachment?.filename}}</span>
            <span *ngIf="!!attachment && !!attachment.fileName"> {{ attachment?.fileName}}</span>
        </div>
        <div>
            <mat-icon class="mdi-24px" fontSet="mdi" fontIcon="mdi-download" (click)="downloadFile()" *ngIf="!isDraft"></mat-icon>
            <mat-icon class="mdi-24px" fontSet="mdi" fontIcon="mdi-close" (click)="close()"></mat-icon>
        </div>
      </div>


    <div *ngIf="!isRenderableFile && !isPdfFile && !isMailAttachment && !isDraft && !markdownFile" class="not-render-file-text 0" (click)="downloadFile()">
        <ng-container  *ngIf="!prevDocx">
          {{ 'BRIEFCASE.CAN_NOT_GENERATE_PREVIEW' | translate }} <span class="download">{{ 'BRIEFCASE.DOWNLOAD_LBL' | translate }} </span> {{ 'BRIEFCASE.IT_LBL' | translate }}
        </ng-container>
       <div *ngIf="prevDocx" class="collabora-div">
            <iframe
              [src]="prevDocx"
              width="100%"
                height="100%"
                style="border: none;"
              ></iframe>
        </div>
    </div>
    <div *ngIf="!isRenderableFile && !isPdfFile && !isMailAttachment && isDraft && !markdownFile" class="not-render-file-text">
        {{ 'BRIEFCASE.CAN_NOT_GENERATE_PREVIEW_DRAFT' | translate }}
    </div>
    <div *ngIf="isRenderableFile && !isPdfFile && !showOfficeViewer && !markdownFile" class="ifram-div ifram-div-img">
      <iframe [src]="displayFileURL"  align="center" id="imgPriview" *ngIf="!isImageVideo"></iframe>
      <pinch-zoom #pinchZoom transition-duration="100" height="100%" style="width: 100vw;height:100%"  *ngIf="isImageVideo">
        <img  id="imageInPreview" [src]="displayFileURL"
           />
      </pinch-zoom>
    </div>
    <div *ngIf="isRenderableFile && showOfficeViewer && this.officeContent === 'OFC'" class="office-viewer-div">
      <onlyoffice [config]="officeConfig"></onlyoffice>

    </div>

    <div *ngIf="(showOfficeViewer && !isPdfFile ) && this.officeContent === 'COLLAB'" class="office-viewer-div">
      <div *ngIf="prevDocx" class="collabora-div">
        <iframe
          [src]="prevDocx"
          width="100%"
          height="100%"
          style="border: none;"
        ></iframe>
      </div>
    </div>

    <div *ngIf="isRenderableFile && markdownFile" class="markdown-preview">
      <markdown
        *ngIf="displayFileContent"
        [data]="displayFileContent">
      </markdown>

    </div>

    <div *ngIf="isMailAttachment && previewMail && previewMail.id !== '' " class="mail-attachment-detail">
      <vp-mail-detail [previewMail]="previewMail" *ngIf="previewMail.id != ''"></vp-mail-detail>
    </div>
    <div *ngIf="isPdfFile && !showOfficeViewer" class="ifram-pdf-div">
      <ng2-pdfjs-viewer pdfSrc="{{PdfUrl}}" viewerId="pdfViewer" style="height: 400px" openFile=false [download]="false"	>
      </ng2-pdfjs-viewer>
    </div>
  </div>
